import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Col, Row } from 'react-bootstrap';
import { Input, FormActions, Checkbox, Select } from '../../common/components/formControls';
import CentersDropdownList from '../centers/DropdownList';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, onReset, initialize, loading, discountTypes, workWithKindergarten, t }) => {
	const handleReset = () => {
		initialize({});
		onReset();
	};
	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit}>
					<Row>
						<Col sm={6}>
							<Field name='name' component={Input} type='text' label={t('Discount_Name')} />
						</Col>
						<Col sm={6}>
							<CentersDropdownList render='field' name='centerId' label={t('Discount_Center')} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Select name='typeId' label={t('Discount_Type')} data={discountTypes} />
						</Col>
						<Col sm={6}>
							<Field name='promoCode' component={Input} type='text' label={t('Discount_PromoCode')} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='value' component={Input} type='text' label={t('Discount_Value')} />
						</Col>
						<Col sm={6}>
							<Field name='isActive' component={Input} componentClass='select' label={t('Discount_IsActive')}>
								<option value={''}>{t('Common_All')}</option>
								<option value={true}>{t('Common_Yes')}</option>
								<option value={false}>{t('Common_No')}</option>
							</Field>
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='currentlyActiveOnly' component={Checkbox} label={t('Discount_CurrentlyActiveOnly')} normalize={(v) => { return !!v }} />
						</Col>
						{workWithKindergarten && <Col sm={6}>
							<Field name='includeKindergarten' component={Checkbox} label={t('Discount_IncludeKindergarten')} normalize={(v) => { return !!v }} />
						</Col>}
					</Row>
					<FormActions>
						<Button type='submit' disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<Button disabled={loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'discountsFilter' })(withTranslation()(Filter));